import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";

// Read API enabled flag from data attribute (set by WordPress)
const rootElement = document.getElementById("root");
const apiEnabled = rootElement?.getAttribute("data-api-enabled") !== "false";

// Store globally for API functions to check
window.AIRMAP_CONFIG = {
  apiEnabled: apiEnabled,
};

const root = ReactDOM.createRoot(rootElement);
root.render(<App />);
